<div class="flex gap-5 my-4" (click)="selectObj(obj)">
  <div class="min-w-[100px] aspect-square image relative"
    [ngStyle]="{ background: 'url(' + (obj.images.length > 0 ? obj.images[0].image_url : '../../../assets/images/image.png') + ')' }"
    [ngClass]="{ 'min-w-[160px]': isWeb }">
  <div *ngIf="obj?.featured || obj?.is_featured || obj?.featured_until" class="featured-star" [attr.aria-label]="'LISTING.FEATURED_TITLE' | translate">
      <ion-icon name="star"></ion-icon>
      <span class="sr-only">{{ 'LISTING.FEATURED_TITLE' | translate }}</span>
    </div>
  </div>
  <div class="flex flex-col justify-center overflow-hidden" [ngClass]="{ '!justify-normal': isWeb }" style="width: 100% !important;">
    <ion-label class="text-sm font-bold whitespace-nowrap overflow-hidden text-ellipsis"
      [ngClass]="{ 'text-base': isWeb }">{{ obj.title }}</ion-label>
    <div class="flex items-center py-1 gap-1 justify-between w-full">
      <div class="flex items-center gap-1">
        <ion-icon src="../../../assets/svg/location.svg"></ion-icon>
        <ion-label class="text-[10px] font-medium italic text-[#7a7a7e]" [ngClass]="{ 'text-[12px]': isWeb }">
          {{ obj.province }}</ion-label>
      </div>
      <ion-label class="text-[10px] text-[#7a7a7e] text-right" [ngClass]="{ 'text-[12px]': isWeb }">{{ obj.created_at | date: 'dd/MM/yyyy' }}</ion-label>
    </div>
    <hr class="mb-1"/>
    <!-- Estado como etiqueta/badge de color para mayor claridad visual -->
    <span
      class="px-2 inline-flex w-fit items-center rounded uppercase font-semibold text-white"
      [ngClass]="{
        'px-2': true,
        'bg-green-600': obj.type === 'found',
        'bg-red-600': obj.type !== 'found',
        'text-[12px] py-1': isWeb,
        'text-[10px] py-[2px]': !isWeb
      }"
    >
      {{ obj.type === 'found' ? ('POST_ITEM.FOUND' | translate) : ('POST_ITEM.LOST' | translate) }}
    </span>
    <ion-label class="text-[10px] text-[#666666] max-h-[45px] overflow-hidden text-ellipsis line-clamp-3"
      [ngClass]="{ 'text-[12px] max-h-[60px]': isWeb }">{{ obj.description }}</ion-label>
  </div>
</div>
